import React from "react";
import { useMachine } from "@xstate/react";
import { useTranslation } from "react-i18next";
import { Divider, useTheme } from "@mui/material";
import { LoadingPlaceHolder } from "@rentablo/components";
import { Banner } from "@rentablo/components";
import { SettingsLayout } from "../components/SettingsLayout";
import { settings2FASM } from "./stateMachine";
import { InfoView } from "./components/InfoView";
import { SetupView } from "./components/SetupView";
import { DisableView } from "./components/DisableView";

export const Settings2FAPage = () => {
  const [currentState, sendEvent] = useMachine(settings2FASM);
  const { t } = useTranslation();
  const theme = useTheme();
  const context = currentState.context;

  const isLoading = currentState.matches("loading");
  const isEnabling = currentState.matches("enabling2FA");
  const isDisabling = currentState.matches("disabling2FA");

  return (
    <SettingsLayout
      breadcrumbs={[
        { text: t("settings.sidebar.title") },
        { text: t("settings.sidebar.twoFA.title") },
      ]}
      title={t("settings.twoFA.title")}
      subtitle={t("settings.twoFA.subtitle")}
    >
      {context.message && context.messageType && (
        <Banner
          title={context.messageTitle}
          text={context.message}
          type={context.messageType}
          displayDefaultIcon
        />
      )}
      <Divider sx={{ my: 7, borderColor: theme.palette.border.secondary }} />

      {isLoading && <LoadingPlaceHolder />}
      {(currentState.matches("idle") || currentState.matches("loadSecret")) && (
        <InfoView
          context={context}
          onToggle={() => sendEvent({ type: "TOGGLE" })}
        />
      )}
      {(currentState.matches("setup") || isEnabling) && (
        <SetupView
          context={context}
          onSubmit={(code) => sendEvent({ type: "SUBMIT_CODE", code })}
          isLoading={isEnabling}
        />
      )}
      {(currentState.matches("disable") || isDisabling) && (
        <DisableView
          onDisable={(code) => sendEvent({ type: "SUBMIT_CODE", code })}
          isLoading={isDisabling}
        />
      )}
    </SettingsLayout>
  );
};
